module.exports = __webpack_public_path__ + "16503b687da6277146025c36c7f8bf2e.svg";